export default function Footer() {
  const scrollTo = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-fill text-background-50 text-base"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">咻咻漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-md mb-4">
              咻咻漫画是国内领先的全集漫画一站式阅读平台，汇集全集韩漫、全集国漫及日漫完结佳作，全部免费下拉式畅读，为漫画爱好者提供极致的阅读体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-arrow-up-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">
              <a href="#index" onClick={(e) => { e.preventDefault(); scrollTo('#index'); }} className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门话题', anchor: '#topics' },
                { label: '常见问题', anchor: '#faq' },
                { label: '更新快讯', anchor: '#updates' },
                { label: '精选专题', anchor: '#carousel' },
                { label: '关于我们', anchor: '#about' },
              ].map((item) => (
                <li key={item.anchor}>
                  <a
                    href={item.anchor}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.anchor); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质漫画平台与内容创作者加入合作，共同打造更好的漫画阅读生态。
            </p>
            <div className="mt-4 space-y-2">
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>contact@xiuxiumanga.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-wechat-line"></i>
                <span>微信公众号：咻咻漫画</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 咻咻漫画 —— 全集漫画免费下拉式阅读平台
          </p>
          <p className="text-xs text-background-600">
            韩漫全集 · 国漫全集 · 日漫经典 · 全部免费
          </p>
        </div>
      </div>
    </footer>
  );
}